import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

const BookingCancel = () => {
  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center animate-fadeInUp">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-slate-800 border border-slate-700 mb-6">
          <XCircle className="w-10 h-10 text-slate-400" />
        </div>
        <h1 className="font-serif text-3xl text-white mb-4">Payment Cancelled</h1>
        <p className="text-slate-400 mb-8">
          Your payment was not completed. Your booking has been saved and you can try again anytime.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button 
              data-testid="return-home-btn"
              className="bg-[#D4AF37] text-slate-950 hover:bg-[#B5952F] font-medium px-8 py-6 rounded-none uppercase tracking-widest text-sm w-full sm:w-auto"
            >
              Book Again
            </Button>
          </Link>
          <Link to="/">
            <Button 
              variant="outline"
              className="bg-transparent border border-slate-700 text-slate-200 hover:border-slate-500 hover:text-white hover:bg-transparent px-8 py-6 rounded-none uppercase tracking-widest text-sm w-full sm:w-auto"
            >
              Return Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookingCancel;
